import { createGtm } from '@gtm-support/vue-gtm'
import isEmpty from 'lodash/isEmpty'
import { defineNuxtPlugin, useRuntimeConfig } from 'nuxt/app'

export default defineNuxtPlugin((nuxtApp) => {
  const gtmConfig = useRuntimeConfig().public.GTM_ID
  const gtmId: string = !isEmpty(gtmConfig) ? gtmConfig : 'GTM-XXXXXX'
  nuxtApp.vueApp.use(
    createGtm({
      id: gtmId,
      defer: false,
      compatibility: false,
      enabled: true,
      debug: false,
      loadScript: true,
      trackOnNextTick: false,
    }),
  )
})
